import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import classes from "./StudentPersonalDetailsLayout.scss";
import SectionHeader from "../SectionHeader";
import { TRANSCRIPT_DATA_SOURCE } from "../../module/constants";
import SyncButton from "../SyncButton";

const StudentPersonalDetailsLayout = ({
  lastSyncAt,
  children,
  isLoading,
  onSyncClick,
  isSyncing,
  isEditMode,
  canEdit,
}) => {
  const { t } = useTranslation();

  const rightComponent = useMemo(() => {
    if (isEditMode || isLoading || !canEdit) return null;

    return (
      <SyncButton
        isSyncing={isSyncing}
        testId="student-personal-details-sync-button"
        onSyncClick={onSyncClick}
      />
    );
  }, [isEditMode, isLoading, isSyncing, onSyncClick, canEdit]);

  return (
    <div className={classes.container}>
      <SectionHeader
        lastSyncAt={lastSyncAt}
        isLoading={isLoading}
        dataSource={TRANSCRIPT_DATA_SOURCE.TODDLE}
        title={t("transcript:basic_details")}
        rightComponent={rightComponent}
      />
      <div className={classes.content}>{children}</div>
    </div>
  );
};

StudentPersonalDetailsLayout.propTypes = {
  lastSyncAt: PropTypes.string,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  onSyncClick: PropTypes.func,
  isSyncing: PropTypes.bool,
  isEditMode: PropTypes.bool,
  canEdit: PropTypes.bool,
};

StudentPersonalDetailsLayout.defaultProps = {
  lastSyncAt: undefined,
  children: null,
  isLoading: false,
  onSyncClick: () => {},
  isSyncing: false,
  isEditMode: false,
  canEdit: false,
};

export default memo(StudentPersonalDetailsLayout);
